import React, { useState, useEffect } from "react";
import CreationModal from "./EntityRegistration/CreationModal";
import DeletionModal from "./EntityRegistration/DeletionModal";
import DeletionSuccessModal from "./EntityRegistration/DeletionSuccessModal";
import RegistrationResultModal from "./EntityRegistration/RegistrationResultModal";

const REGISTRATION_RESULT_KEY = "entityRegistrationResult";

const EntityRegistrationCard = (props) => {
  const [registrations, setRegistrations] = useState(props.registrations || []);
  const [expanded, setExpanded] = useState(false);
  const [registrationToDelete, setRegistrationToDelete] = useState(null);
  const [displayCreationModal, setDisplayCreationModal] = useState(false);
  const [displayDeletionModal, setDisplayDeletionModal] = useState(false);
  const [displayDeletionSuccessModal, setDisplayDeletionSuccessModal] = useState(false);
  const [displayRegistrationResultModal, setDisplayRegistrationResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem(REGISTRATION_RESULT_KEY);
    if (stored) {
      try {
        setRegistrationResult(JSON.parse(stored));
        setDisplayRegistrationResultModal(true);
      } catch (e) {
        console.error("Failed to parse registration result:", e);
      } finally {
        sessionStorage.removeItem(REGISTRATION_RESULT_KEY);
      }
    }
  }, []);

  const visibleRegistrations = expanded ? registrations : registrations.slice(0, 3);

  const renderCreationModal = () => {
    if (!displayCreationModal) return null;

    return (
      <CreationModal
        closeModal={() => setDisplayCreationModal(false)}
        resultKey={REGISTRATION_RESULT_KEY}
        organizationID={props.organizationID}
      />
    );
  };

  const renderDeletionModal = () => {
    if (!displayDeletionModal) return null;

    return (
      <DeletionModal
        registration={registrationToDelete}
        setRegistrations={setRegistrations}
        handleSubmit={handleDeletionSubmit}
        closeModal={() => setDisplayDeletionModal(false)}
      />
    );
  };

  const renderDeletionSuccessModal = () => {
    if (!displayDeletionSuccessModal) return null;

    return (
      <DeletionSuccessModal
        registration={registrationToDelete}
        closeModal={() => setDisplayDeletionSuccessModal(false)}
      />
    );
  };

  const renderRegistrationResultModal = () => {
    if (!displayRegistrationResultModal) {
      return null;
    }

    return (
      <RegistrationResultModal
        registrationResult={registrationResult}
        closeModal={() => setDisplayRegistrationResultModal(false)}
      />
    );
  };

  const handleDeletionSubmit = async (e, registration) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    try {
      const response = await fetch(
        `/organization/${registration.organization_id}/pending_registrations/${registration.id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
        }
      );

      const data = await response.json();

      if (!response.ok) throw new Error(data.error);

      setRegistrations((prev) => prev.filter((r) => r.id != registration.id));
      setDisplayDeletionModal(false);
      setDisplayDeletionSuccessModal(true);
    } catch (error) {
      props.setNotice({
        kind: "error",
        open: true,
        message: error.message || "An error occurred.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="draw__item__container">
      <div className="action_required__container">
        <div className="action_required__contents">
          <div className="flex--col gap--4">
            <div className="t--700">New Entity Enrollment</div>
            <div className="t--sm t--subtitle">Add an entity to your 340B ESP account.</div>
          </div>
          <button
            className="button button--white button--lg"
            onClick={() => setDisplayCreationModal(true)}
          >
            Add New Entity
          </button>
          {registrations.length ? (
            <>
              <div className="draw__container__divider draw__container__divider--full-width" />
              <div className="flex--col gap--16">
                <div className="flex--col gap--4">
                  <div className="t--700">Enrollments in Review</div>
                  <div className="t--sm t--subtitle">340B ESP Support is reviewing.</div>
                </div>
                {visibleRegistrations.map((registration) => (
                  <div key={registration.id_340b} className="flex justify-space-between gap--16">
                    <div className="action_required__entity_details">
                      <div
                        className="action_required__entity_details__title t--truncate"
                        title={registration.entity_name}
                      >
                        {registration.entity_name}
                      </div>
                      <div>{registration.id_340b}</div>
                    </div>
                    <div className="button button--white button--sq-lg">
                      <span
                        className="material-symbols-rounded"
                        style={{ fontSize: 18 }}
                        onClick={() => {
                          setRegistrationToDelete(registration);
                          setDisplayDeletionModal(true);
                        }}
                      >
                        delete
                      </span>
                    </div>
                  </div>
                ))}
                {registrations.length > 3 ? (
                  <>
                    <div className="draw__container__divider draw__container__divider--full-width" />
                    <button
                      onClick={() => setExpanded(!expanded)}
                      className="draw__container__toggle"
                    >
                      <span className="draw__container__toggle__button">
                        {expanded ? "Show less" : "Show more"}
                      </span>
                    </button>
                  </>
                ) : null}
              </div>
            </>
          ) : null}
        </div>
      </div>
      {renderCreationModal()}

      {renderDeletionModal()}

      {renderDeletionSuccessModal()}

      {renderRegistrationResultModal()}
    </div>
  );
};

export default EntityRegistrationCard;
